import { GlobalState } from '@leverege/ui-redux';
import { Relationships } from '@leverege/ui-attributes';
import { matchPath } from 'react-router';
import RsrcRelationship from "./RsrcRelationship.js";
import ImagineRsrcItemDelegate from "./ImagineRsrcItemDelegate.js";
let lastRel = null;
let relationships = [];
export default class RsrcDataSource {
  constructor(blueprint) {
    this.blueprint = blueprint;
  }
  dataSource() {
    return this.blueprint.name;
  }
  getData(objRef) {
    const state = GlobalState.get();
    const {
      ownerId,
      data
    } = objRef.data || {};
    if (!ownerId || !data) {
      return undefined;
    }
    const {
      path
    } = data;
    return state.rsrcs.owner?.[ownerId]?.rsrcs?.[path]?.value;
  }
  getDelegate(objRef) {
    const relationship = RsrcDataSource.getRelationship(objRef);
    if (relationship != null) {
      return new ImagineRsrcItemDelegate({
        match: relationship.match,
        relationship: relationship.relationship.createResolved(relationship.match)
      });
    }
    return null;
  }
  static getRelationship(objRef) {
    const {
      ref,
      data
    } = objRef;
    if (!data?.path) {
      return null;
    }
    return getRelationshipFor(`${ref}/${encodeURIComponent(data.path)}`);
  }
}
function getRelationshipFor(ref) {
  if (lastRel !== Relationships.getAll()) {
    lastRel = Relationships.getAll();
    relationships = lastRel.filter(rel => rel instanceof RsrcRelationship).map(rel => {
      const r = rel.createItem();
      const lastSegment = r.objRefUrlPath.substring(r.objRefUrlPath.lastIndexOf('/') + 1);
      const match = {
        path: lastSegment.includes(':') ? r.objRefUrlPath : r.objRefUrlPath.replace(lastSegment, `:${lastSegment}Id`),
        exact: true,
        strict: true
      };
      return {
        match,
        relationship: r
      };
    });
    sort();
  }
  for (let n = 0; n < relationships.length; n++) {
    const rel = relationships[n];
    const match = matchPath(ref, rel.match);
    if (match) {
      return {
        match: {
          ...match,
          url: decodeURIComponent(match.url),
          params: Object.entries(match.params).reduce((prev, [key, value]) => {
            prev[key] = decodeURIComponent(value);
            return prev;
          }, {})
        },
        relationship: rel.relationship
      };
    }
  }
  return null;
}
function sort() {
  relationships.sort((a, b) => {
    return a.relationship.objRefUrlPath.localeCompare(b.relationship.objRefUrlPath);
  });
}